import { createContext } from "react";

export interface SupportChatContextValue {
    isOpen: boolean;
    openSupportChat: () => void;
    closeSupportChat: () => void;
    toggleSupportChat: () => void;
}

export const SupportChatContext = createContext<SupportChatContextValue | null>(
    null,
);
